import React, { ForwardRefRenderFunction } from "react";
//#region types
import { IncomingInvoiceUpdatePaymentFormContainerProps } from "models/propTypes/incomingInvoicePropTypes";
import { IncomingInvoiceFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import IncomingInvoiceUpdatePaymentForm from "./updatePaymentForm";
import { useIncomingInvoiceService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const IncomingInvoiceUpdatePaymentFormContainer: ForwardRefRenderFunction<
  FormHandles,
  IncomingInvoiceUpdatePaymentFormContainerProps
> = (props, ref) => {
  const incomingInvoiceService = useIncomingInvoiceService();
  const validationSchema = Yup.object<IncomingInvoiceFormTypes.UpdatePayment>({
    paymentDate: Yup.date().typeError(TranslationKeys.Validations.InvalidDate),
  });

  const defaultValues = {
    isAlreadyPaid: props.isAlreadyPaid,
    paymentDate: props.paymentDate,
  } as IncomingInvoiceFormTypes.UpdatePayment;

  const handleSubmit = async (values: IncomingInvoiceFormTypes.UpdatePayment) => {
    await incomingInvoiceService.toggleAlreadyPaid(props.invoiceId, undefined, values.paymentDate ?? undefined);

    return values;
  };

  return (
    <IncomingInvoiceUpdatePaymentForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
    />
  );
};

export default React.forwardRef(IncomingInvoiceUpdatePaymentFormContainer);
